import React from 'react';
import LoginPage from './containers/LoginPage';
import DemoPage from './components/DemoPage';
import { LanguageProvider } from './context/LanguageContext';
import './App.css';

function App() {
  // 开发模式下可以通过URL参数切换到演示页面
  const isDemoMode = window.location.search.includes('demo=true');

  return (
    <LanguageProvider>
      <div className="App">
        {/* {isDemoMode ? <DemoPage /> : <LoginPage />} */}
        <LoginPage />
      </div>
    </LanguageProvider>
  );
}

export default App; 